import type { NodeParameters } from '../../../types/node-properties';

/**
 * Default parameter values for MCP Tool node
 */
const defaults: NodeParameters = {
  operation: 'listTools',
  transportType: 'http',
  mcpServerUrl: '',
  stdioCommand: 'npx',
  stdioArgs: [],
  stdioEnv: {},
  authType: 'none',
  bearerToken: '',
  customHeaderName: 'X-API-Key',
  customHeaderValue: '',
  toolName: '',
  toolArguments: {},
  timeout: 60000,
  retryOnFailure: false,
  maxRetries: 3,
  toolDescriptionMode: 'auto',
  toolDescription: ''
};

export default defaults;
